import {getHeaders} from '@/utils';

import axios from 'axios';
import {removeDecimals, removeRegisterStatus, removeToken, removeUser} from "@/helpers/local-storage";
import {goURL} from "@/helpers/router";
// Make an 'instance' of axios
const instance = axios.create({
    // .. where we make our configurations
    baseURL: process.env.API_SERVER_URL,
});

// Add configure interceptors && all the other cool stuff
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        console.error('@@@axios interceptor error: ', error.response);

        // unauthenticated
        if (error.response.status === 401 && error.response.config.url !== '/api/auth/signin') {
            // clear localstorage
            removeToken();
            removeUser();
            removeDecimals();
            removeRegisterStatus();
			
			// return error code to display
            return Promise.reject({response: {code: error.response.status}})
        }

        return Promise.reject(error.response);
    },
);

export default instance;
